import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {Entidade} from "../../domain/Entidade";
import {NgForm} from "@angular/forms";
import {ToastController} from "@ionic/angular";

@Component({
  selector: 'app-edit-dialog-abstract',
  template: '',
  styles: ['']
})
export abstract class OneToManyComponent<T extends Entidade> {
  item: T =  this.newObject()
  original? : T
  isOpen = false;
  novo = false

  @ViewChild("form")
  entidadeForm?: NgForm

  constructor( private toast: ToastController) {
  }

  exibir= true

  get icone(): string{
    return !this.exibir ? "arrow-down" : "arrow-up"
  }

  trocar(){
    this.exibir =!this.exibir
  }

  abstract newObject(): T
  _entidades: T[] = []

  @Input()
  set entidades(valor: T[]){
    this._entidades = valor
  }

  get entidades(): T[]{
    return this._entidades
  }

  @Output() entidadesChange = new EventEmitter<T[]>();

  close(){
    this.isOpen = false
  }

  async add(){
        this.isOpen = true
        this.exibir = true
        this.novo = true
        this.item = this.newObject()
  }

  protected async message(message: string, tipo = 'ok'|| 'erro'){
    const toast = await this.toast.create({
      message: message,
      position: "middle",
      duration: 3000,
      icon: tipo == 'ok' ? 'checkmark' : 'close-circle'
    });
    await toast.present()
  }

  edit(met: T){
    //Deep copy
    this.original = met
    const json = JSON.stringify(met)
    this.item = JSON.parse(json)
    this.novo = false
    this.isOpen = true
  }

  delete(item: T){
    console.log('excluir',item)
    console.log('entidades',this.entidades)
    item.excluido = true
    const index = this.entidades.indexOf(item);
    this.entidades.splice(index, 1);
    this.entidadesChange.emit(this.entidades)
  }

  deleteSelected(){
    this.delete(this.original!!)
    this.isOpen = false
  }

  async save(){
    if (this.entidadeForm?.valid) {
      if(this.novo){
        this.entidades = this.entidades || []
        this.entidades.push(this.item)
      } else {
        Object.assign(this.original!!, this.item)
      }
      this.entidadesChange.emit(this.entidades)
      this.isOpen = false
    } else {
      console.log(this.entidadeForm?.errors)
      await this.message('Campos Inválidos ou não preenchidos', 'error')
    }
  }

}
